/**
 * Reports registry (S11.1) — the route-derived tab set (`/auth/reports/:report`).
 *
 * The five pink reports (Board D #11): 訂單毛利 · 未出貨-客人 Back Order ·
 * 未進貨-供應商 · 未收款 · 未付款. Tabs are ROUTE-DERIVED (route-derived
 * selection tenet, mirroring the OCC lens registry) so a deep link selects a
 * report and an unknown key falls back to the landing report.
 *
 * The codex `/auth/reports/ops` fixture (EnginesPages OpsReportsPage) was
 * RETIRED in W11 — its URL now falls through this `:report` param to the
 * landing report, and the 報表 nav wires the five reports directly.
 */

export const REPORT_KEYS = [
  'order-margin',
  'back-order',
  'unreceived',
  'receivables',
  'payables',
] as const;

export type ReportKey = (typeof REPORT_KEYS)[number];

export interface ReportDef {
  key: ReportKey;
  /** Tab label key in the `reports` namespace. */
  tabKey: string;
  /** Per-report i18n sub-namespace (title / formula / columns live under it). */
  ns: string;
}

export const REPORT_DEFS: readonly ReportDef[] = [
  { key: 'order-margin', tabKey: 'reports.tabs.orderMargin', ns: 'orderMargin' },
  { key: 'back-order', tabKey: 'reports.tabs.backOrder', ns: 'backOrder' },
  { key: 'unreceived', tabKey: 'reports.tabs.unreceived', ns: 'unreceived' },
  { key: 'receivables', tabKey: 'reports.tabs.receivables', ns: 'receivables' },
  { key: 'payables', tabKey: 'reports.tabs.payables', ns: 'payables' },
];

/** Landing report = 訂單毛利 Order Gross Profit. */
export const REPORT_DEFAULT: ReportKey = 'order-margin';

export function isReportKey(value: string | undefined): value is ReportKey {
  return Boolean(value) && (REPORT_KEYS as readonly string[]).includes(value as string);
}
